/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetBondListResponse,
  UtxBondApiGetBondListParams,
  CreateBondSubscriptionRequest,
  GetBondAccountsListResponse,
  GetBondTransactionListResponse,
  UtxBondApiGetBondTransferListParams,
  GetBondRedemptionListResponse,
  UtxBondApiGetBondRedemptionListParams,
  WmcBondFilterResponse,
  UtxBondApiWmcFundFilterParams,
  CanRedemptionListResponse,
  GetBondDetailResponse,
  CreateBondRedemptionRequest,
  RequestBondAccountResponse
} from './schema'



export const utxBondApiGetBondList = (
    params: UtxBondApiGetBondListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBondListResponse[]>> => {
    return axios.get(
      `/Bond`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBondApiGetBondListQueryKey = (params: UtxBondApiGetBondListParams,) => [`/Bond`, ...(params ? [params]: [])];

    
export type UtxBondApiGetBondListQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiGetBondList>>>
export type UtxBondApiGetBondListQueryError = AxiosError<unknown>

export const useUtxBondApiGetBondList = <TData = Awaited<ReturnType<typeof utxBondApiGetBondList>>, TError = AxiosError<unknown>>(
 params: UtxBondApiGetBondListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiGetBondList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiGetBondListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiGetBondList>>> = ({ signal }) => utxBondApiGetBondList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiGetBondList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiBondSubscription = (
    createBondSubscriptionRequest: CreateBondSubscriptionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/Bond/subscription`,
      createBondSubscriptionRequest,options
    );
  }



    export type UtxBondApiBondSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof utxBondApiBondSubscription>>>
    export type UtxBondApiBondSubscriptionMutationBody = CreateBondSubscriptionRequest
    export type UtxBondApiBondSubscriptionMutationError = AxiosError<unknown>

    export const useUtxBondApiBondSubscription = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBondApiBondSubscription>>, TError,{data: CreateBondSubscriptionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBondApiBondSubscription>>, {data: CreateBondSubscriptionRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxBondApiBondSubscription(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBondApiBondSubscription>>, TError, {data: CreateBondSubscriptionRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxBondApiGetBondSubscriptionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBondAccountsListResponse[]>> => {
    return axios.get(
      `/Bond/accounts`,options
    );
  }


export const getUtxBondApiGetBondSubscriptionListQueryKey = () => [`/Bond/accounts`];

    
export type UtxBondApiGetBondSubscriptionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiGetBondSubscriptionList>>>
export type UtxBondApiGetBondSubscriptionListQueryError = AxiosError<unknown>

export const useUtxBondApiGetBondSubscriptionList = <TData = Awaited<ReturnType<typeof utxBondApiGetBondSubscriptionList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiGetBondSubscriptionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiGetBondSubscriptionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiGetBondSubscriptionList>>> = ({ signal }) => utxBondApiGetBondSubscriptionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiGetBondSubscriptionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiGetBondTransferList = (
    params: UtxBondApiGetBondTransferListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBondTransactionListResponse[]>> => {
    return axios.get(
      `/Bond/transaction`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBondApiGetBondTransferListQueryKey = (params: UtxBondApiGetBondTransferListParams,) => [`/Bond/transaction`, ...(params ? [params]: [])];

    
export type UtxBondApiGetBondTransferListQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiGetBondTransferList>>>
export type UtxBondApiGetBondTransferListQueryError = AxiosError<unknown>

export const useUtxBondApiGetBondTransferList = <TData = Awaited<ReturnType<typeof utxBondApiGetBondTransferList>>, TError = AxiosError<unknown>>(
 params: UtxBondApiGetBondTransferListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiGetBondTransferList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiGetBondTransferListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiGetBondTransferList>>> = ({ signal }) => utxBondApiGetBondTransferList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiGetBondTransferList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiGetBondRedemptionList = (
    params: UtxBondApiGetBondRedemptionListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBondRedemptionListResponse[]>> => {
    return axios.get(
      `/Bond/redemption-list`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBondApiGetBondRedemptionListQueryKey = (params: UtxBondApiGetBondRedemptionListParams,) => [`/Bond/redemption-list`, ...(params ? [params]: [])];

    
export type UtxBondApiGetBondRedemptionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiGetBondRedemptionList>>>
export type UtxBondApiGetBondRedemptionListQueryError = AxiosError<unknown>

export const useUtxBondApiGetBondRedemptionList = <TData = Awaited<ReturnType<typeof utxBondApiGetBondRedemptionList>>, TError = AxiosError<unknown>>(
 params: UtxBondApiGetBondRedemptionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiGetBondRedemptionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiGetBondRedemptionListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiGetBondRedemptionList>>> = ({ signal }) => utxBondApiGetBondRedemptionList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiGetBondRedemptionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiWmcFundFilter = (
    params?: UtxBondApiWmcFundFilterParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WmcBondFilterResponse>> => {
    return axios.get(
      `/Bond/wmc-bond-filter`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBondApiWmcFundFilterQueryKey = (params?: UtxBondApiWmcFundFilterParams,) => [`/Bond/wmc-bond-filter`, ...(params ? [params]: [])];

    
export type UtxBondApiWmcFundFilterQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiWmcFundFilter>>>
export type UtxBondApiWmcFundFilterQueryError = AxiosError<unknown>

export const useUtxBondApiWmcFundFilter = <TData = Awaited<ReturnType<typeof utxBondApiWmcFundFilter>>, TError = AxiosError<unknown>>(
 params?: UtxBondApiWmcFundFilterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiWmcFundFilter>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiWmcFundFilterQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiWmcFundFilter>>> = ({ signal }) => utxBondApiWmcFundFilter(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiWmcFundFilter>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiCanRedemptionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CanRedemptionListResponse>> => {
    return axios.get(
      `/Bond/can-redemption-list`,options
    );
  }


export const getUtxBondApiCanRedemptionListQueryKey = () => [`/Bond/can-redemption-list`];

    
export type UtxBondApiCanRedemptionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiCanRedemptionList>>>
export type UtxBondApiCanRedemptionListQueryError = AxiosError<unknown>

export const useUtxBondApiCanRedemptionList = <TData = Awaited<ReturnType<typeof utxBondApiCanRedemptionList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiCanRedemptionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiCanRedemptionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiCanRedemptionList>>> = ({ signal }) => utxBondApiCanRedemptionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiCanRedemptionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiGetBondDetail = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBondDetailResponse>> => {
    return axios.get(
      `/Bond/${id}`,options
    );
  }


export const getUtxBondApiGetBondDetailQueryKey = (id: string,) => [`/Bond/${id}`];

    
export type UtxBondApiGetBondDetailQueryResult = NonNullable<Awaited<ReturnType<typeof utxBondApiGetBondDetail>>>
export type UtxBondApiGetBondDetailQueryError = AxiosError<unknown>

export const useUtxBondApiGetBondDetail = <TData = Awaited<ReturnType<typeof utxBondApiGetBondDetail>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBondApiGetBondDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBondApiGetBondDetailQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBondApiGetBondDetail>>> = ({ signal }) => utxBondApiGetBondDetail(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBondApiGetBondDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBondApiBondRedemption = (
    createBondRedemptionRequest: CreateBondRedemptionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/Bond/redemption`,
      createBondRedemptionRequest,options
    );
  }



    export type UtxBondApiBondRedemptionMutationResult = NonNullable<Awaited<ReturnType<typeof utxBondApiBondRedemption>>>
    export type UtxBondApiBondRedemptionMutationBody = CreateBondRedemptionRequest
    export type UtxBondApiBondRedemptionMutationError = AxiosError<unknown>

    export const useUtxBondApiBondRedemption = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBondApiBondRedemption>>, TError,{data: CreateBondRedemptionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBondApiBondRedemption>>, {data: CreateBondRedemptionRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxBondApiBondRedemption(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBondApiBondRedemption>>, TError, {data: CreateBondRedemptionRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxBondApiBondOpenAccount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestBondAccountResponse>> => {
    return axios.post(
      `/Bond/open-account`,undefined,options
    );
  }



    export type UtxBondApiBondOpenAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxBondApiBondOpenAccount>>>
    
    export type UtxBondApiBondOpenAccountMutationError = AxiosError<unknown>

    export const useUtxBondApiBondOpenAccount = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBondApiBondOpenAccount>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBondApiBondOpenAccount>>, TVariables> = () => {
          

          return  utxBondApiBondOpenAccount(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBondApiBondOpenAccount>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    